export var domain = typeof window !== 'undefined' && window.location.hostname === 'localhost' ? undefined : '.kbb.com';
export var ZipCodeCookie = 'ZipCode';
export var PersistentZipCodeCookie = 'PersistentZipCode';
export var ZipCodeAkamaiCookie = 'AkamaiZip';
export var LocationCookie = 'kbb-location-data';
export var LocalStorageZipInfo = 'kbb-location';
export var LocalStorageGeoInfo = 'kbb-geolocation';
export var zipCodeExtractRegex = /[\-\+]/g;
export var akamaiHeader = 'x-akamai-edgescape';
export var AkamaiLocationHeader = 'x-akamai-edgescape';
export var AkamaiDeviceHeader = 'x-akamai-device-characteristics';
export var AkamaiSessionInfo = 'x-akamai-session-info';
export var isDevelopment = process.env.NODE_ENV === 'development';